import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Component to handle scroll restoration on route changes
const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // Use auto for instant scroll on route change
    });
  }, [location.pathname]);

  return children || null;
};

// Hook version for functional components
export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [location.pathname]);
};

// Component that scrolls to top on mount
export const ScrollToTopOnMount = ({ behavior = 'auto', delay = 0 }) => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior
      });
    };

    if (delay > 0) {
      const timeoutId = setTimeout(scrollToTop, delay);
      return () => clearTimeout(timeoutId);
    } else {
      scrollToTop();
    }
  }, [behavior, delay]);

  return null;
};

export default ScrollToTop;
